import type { IntentExecuteArgs, IntentSdkContext } from '@/types/sdk/experimental/crosschain/crosschainIntentTypes'
import type { IntentExecuteResponse } from '@vaultsfyi/common/schemas'
import { parseIntentError } from './parseIntentError'

export const executeIntent = async (
  ctx: IntentSdkContext,
  { payloadSignature, originalQuote }: IntentExecuteArgs
): Promise<IntentExecuteResponse> => {
  const response = await fetch(`${ctx.base}/intent/execute`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ payloadSignature, originalQuote, provider: ctx.provider }),
  })

  if (!response.ok) {
    throw await parseIntentError(response, 'Failed to execute crosschain deposit')
  }

  return response.json()
}
